import React from "react";

import { displayDurationTrip } from "../../utils/date.utils";

const DayTripInfo = ({ day }) => {
  const trips = day.trips || [];

  return (
    <div className="my-5" key={day.date}>
      <div className="font-bold text-lg">{day.date}</div>
      <div className="my-2 align-middle">
        {trips.length > 0 ? (
          trips.map((trip, i) => (
            <div className="my-4" key={trip.id}>
              <div className="my-2">
                <span className="my-1 mx-2 font-bold">{`Trajet ${i + 1} :`} </span>
                <span className={`rounded-full ${trip.type.id === 1 ? "bg-green-400" : "bg-red-500"} text-white px-2`}>
                  {`${trip.type.label}`}{" "}
                </span>
              </div>
              <div className="my-2">
                <span className="my-1 mx-2 font-bold">{`Distance : `}</span>
                <span className="text-red-500"> {`${parseInt(trip.distance)}km`} </span>
              </div>
              <div className="my-2">
                <span className="my-1 mx-2 font-bold">{`Durée :`}</span>
                <span>{displayDurationTrip(trip.start_date, trip.end_date)}</span>
              </div>
            </div>
          ))
        ) : (
          <div>Aucun trajet ce jour</div>
        )}
      </div>
    </div>
  );
};
export default function ValidateWeekTrips({ indexWeek, validateTripsWeeks, days = [], closeModal, token, fetchData }) {
  return (
    <div>
      <div className="flex justify-between overflow-auto">
        {days.map(day => (
          <DayTripInfo day={day} key={day.date} />
        ))}
      </div>
      <div>
        <div className="mt-6 flex justify-center">
          <div
            className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full p-btn-grey text-white"
            onClick={closeModal}
          >
            Annuler
          </div>
          <div
            className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-green-400 text-white"
            onClick={() => {
              closeModal();
              validateTripsWeeks({
                ids: days.map(day => day.trips.map(trip => trip.id)).flat(),
                indexWeek: indexWeek
              });
            }}
          >
            Valider les trajets
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/modules/presence/presence/modals/ValidateWeekTrips.js